import React from 'react';

const AIPopupModal = ({ title, content, message, onClose }) => {
  // Fallback: allow older prop `message` if `content` is not passed
  const displayContent = content || message;
  const displayTitle = title || '✨ AI Insight';

  if (!displayContent) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg p-6 shadow-lg max-w-md w-full text-center">
        <h2 className="text-lg font-bold mb-2 text-blue-800">{displayTitle}</h2>
        <p className="text-gray-800 mb-4 whitespace-pre-line max-h-64 overflow-y-auto">
          {displayContent}
        </p>
        <button
          onClick={onClose}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Got it
        </button>
      </div>
    </div>
  );
};

export default AIPopupModal;
